const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class ShoeFinderCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els.slide || this.els.slide?.elements?.length < 2) return

    this.carouselPositionFromStorage = window.localStorage.getItem(
      this.carouselPositionStorageName,
    )

    this.carousel = this.setupCarousel()

    if (this.carouselPositionFromStorage) {
      const index = parseInt(this.carouselPositionFromStorage, 10)
      this.moveToIdx(index)
    }
  }

  setupListeners () {
    super.setupListeners()

    this.handleClick = this.handleClick.bind(this)
    this.listeners.add(document, 'click', this.handleClick)
  }

  handleClick (e) {
    const target = e.target

    if (!target) return

    if (!target.checked) return

    if (target.closest(this.els.input?.selector)) {
      this.handleInputClick(target)
    }

    if (target.closest(this.els.continue?.selector)) {
      this.handleContinueClick()
    }
  }

  handleInputClick (target) {
    const parentSlide = target.closest(this.els.slide?.selector)

    if (!parentSlide) return

    if (parentSlide.dataset.multiChoiceEnabled !== 'true') {
      this.moveToNextSlide()
    }
  }

  handleContinueClick () {
    this.moveToNextSlide()
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        renderMode: 'custom',
        drag: false,
        slides: {
          perView: 1,
          spacing: 0,
        },
        slideChanged: this.onSlideChanged,
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  onSlideChanged (instance) {
    this.updateCurrentSlide(instance)
    this.storePosition(instance)
  }

  updateCurrentSlide (instance) {
    const currentSlide = instance.track.details.rel
    const totalSlides = instance.track.details.slides.length

    const percentage = (currentSlide / (totalSlides - 1)) * 100

    this.els.header.elements.forEach((header, index) => {
      header.setAttribute('aria-hidden', index !== currentSlide)
    })

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })

    this.els.progressBar.element.style.setProperty(
      '--SfControls_ProgressBarWidth',
      `${percentage}%`,
    )

    this.externalEls.footer.element.setAttribute(
      'data-last-slide',
      currentSlide + 1 === totalSlides,
    )
  }

  storePosition (instance) {
    const currentSlide = instance.track.details.rel

    window.localStorage.setItem(this.carouselPositionStorageName, currentSlide)
  }

  moveToIdx (index) {
    if (this.carousel && typeof index === 'number') {
      this.carousel.moveToIdx(index)
    }
  }

  moveToNextSlide () {
    if (this.carousel) {
      this.carousel.next()
    }
  }

  get carouselPositionStorageName () {
    return `BAO-shoe-finder-carousel-position`
  }
}

if (!customElements.get('shoe-finder-carousel')) {
  customElements.define('shoe-finder-carousel', ShoeFinderCarousel)
}
